export default [
  {
    path: '/admin/apply/plugin/article/list',
    name: 'articleList',
    component: () => import('@/views/plugin/article/list'),
    meta: {
      title: '文章管理',
      headType: 0,
      auth: true
    }
  },
  {
    path: '/admin/apply/plugin/article/category',
    name: 'articleCategory',
    component: () => import('@/views/plugin/article/category'),
    meta: {
      title: '文章分类',
      headType: 0,
      auth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/apply/article.js